// extracted by mini-css-extract-plugin
export var errorIcon = "_n0-1";
export var nameLogo = "_n0-0";